import { FormattedMessage, useIntl } from 'react-intl';

import Modal from '@components/Modal';
import BodyCopy from '@components/typography/BodyCopy';
import Heading3 from '@components/typography/Heading3';
import { Opener } from '@hooks/useOpener';

type Props = {
  opener: Opener;
};

const AssignmentWeightExplanationModal = ({ opener }: Props) => {
  const intl = useIntl();

  return (
    <Modal opener={opener} title={intl.formatMessage({ id: 'pages.assignmentWeightExplanation.title' })}>
      {() => (
        <>
          <Heading3>
            <FormattedMessage id="pages.assignmentWeightExplanation.heading" />
          </Heading3>
          <p>
            <BodyCopy>
              <FormattedMessage id="pages.assignmentWeightExplanation.p1" />
            </BodyCopy>
          </p>
          <ul>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.step1" />
              </BodyCopy>
            </li>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.step2" />
              </BodyCopy>
            </li>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.step3" />
              </BodyCopy>
            </li>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.step4" />
              </BodyCopy>
            </li>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.step5" />
              </BodyCopy>
            </li>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.step6" />
              </BodyCopy>
            </li>
          </ul>
          <p>
            <BodyCopy>
              <FormattedMessage id="pages.assignmentWeightExplanation.aFewNotes" />
            </BodyCopy>
          </p>
          <ul>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.note1" />
              </BodyCopy>
            </li>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.note2" />
              </BodyCopy>
            </li>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.note3" />
              </BodyCopy>
            </li>
            <li>
              <BodyCopy>
                <FormattedMessage id="pages.assignmentWeightExplanation.note4" />
              </BodyCopy>
            </li>
          </ul>
        </>
      )}
    </Modal>
  );
};

export default AssignmentWeightExplanationModal;
